import * as React from 'react'

const HOVER_MEDIA_QUERY = '(hover: hover) and (pointer: fine)'

export const usePrefersHover = (): boolean => {
  const [prefersHover, setPrefersHover] = React.useState(() => {
    if (typeof window === 'undefined') {
      return true
    }
    return window.matchMedia(HOVER_MEDIA_QUERY).matches
  })

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(HOVER_MEDIA_QUERY)
    const handleChange = () => setPrefersHover(mediaQuery.matches)

    handleChange()
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return prefersHover
}
